import _ from "lodash";
import { KEY_SEPARATOR } from "../constants";

export const createCompositeKey = (...args) => _.join(args, KEY_SEPARATOR);

export const parseCompositeKey = key => _.split(key, KEY_SEPARATOR);

// Lookup helpers for grade records
export const getGradeRecordKey = ({
  gradeMapId,
  courseId,
  gradingPeriodId,
  criteriaId,
}) => createCompositeKey(gradeMapId, courseId, gradingPeriodId, criteriaId);

export const getDeletedRowKey = ({ gradeMapId, courseId }) =>
  createCompositeKey(gradeMapId, courseId);

export const getCourseLevelKey = ({ gradeMapId, courseId }) =>
  createCompositeKey(gradeMapId, courseId);

export const getCourseCodeKey = ({ gradeMapId, courseId }) =>
  createCompositeKey(gradeMapId, courseId);

export const getNewCourseRatingKey = ({ rowId, gradingPeriodId, criteriaId }) =>
  createCompositeKey(rowId, gradingPeriodId, criteriaId);
